// extracted by mini-css-extract-plugin
export default {"consumerHeaderSearchBar":"ConsumerHeaderSearchBar-module__consumerHeaderSearchBar___gCQUP","withSearchDropdown":"ConsumerHeaderSearchBar-module__withSearchDropdown___1vCkW"};